import React, { useContext, useState, useCallback } from 'react';
import { Button, Spacer, Radios, Title } from '@ontruck/orc';

import { DispatchingContext } from 'modules/ownership-dispatching';

import { useStaffUsers } from './hooks';
import { bulkHandlerAssignment } from './http';

const t = {
  title: 'Assign selected jobs to:',
  assign: 'Assign selected jobs',
  no_owner: 'No owner',
};

const noOwnerValue = 'no_owner';

const DispatchingUsers = ({ className }) => {
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [loading, setLoading] = useState(false);
  const { data } = useStaffUsers();
  const { selectedJourneys, clearJourneys } = useContext(DispatchingContext);

  const onChange = useCallback((e, { value }) => {
    setSelectedAgent(value);
  }, []);

  const onClick = useCallback(async () => {
    setLoading(true);
    bulkHandlerAssignment({
      agent: selectedAgent === noOwnerValue ? null : selectedAgent,
      ids: selectedJourneys,
    });
    setLoading(false);
    clearJourneys();
  }, [clearJourneys, selectedJourneys, selectedAgent]);

  const radiosData = data.map(({ id, first_name, last_name }) => ({
    value: String(id),
    label: `${first_name} ${last_name}`,
  }));

  const dataWithNoOwner = [...radiosData, { value: noOwnerValue, label: t.no_owner }];

  const isDisabled = !selectedAgent || !selectedJourneys.length || loading;

  return (
    <div className={className}>
      <Title text={t.title} size="M" level="h3" />
      {!!data.length && (
        <Spacer mTop="S">
          <Radios value={selectedAgent} name="users" items={dataWithNoOwner} onChange={onChange} />
          <Spacer mTop="S">
            <Button onClick={onClick} disabled={isDisabled} fullWidth>
              {t.assign}
            </Button>
          </Spacer>
        </Spacer>
      )}
    </div>
  );
};

export default DispatchingUsers;
